// Qué dice la pastilla del agente en el teléfono y qué abre al tocarla
// (ADR-2026-10-15-el-catalogo-en-el-telefono). Puro.
import type { EstadoDelAgenteMobile } from './AgenteDelCatalogoMobile';

export interface EstadoDeLaPastilla {
  trabajando: boolean;
  /** Lo que el agente está haciendo, como lo cuenta el chat ("Escribiendo los prompts…"). */
  actividad?: string | null;
  /** Una tarjeta del agente esperando respuesta (una pregunta, un "¿genero?"). */
  pregunta: boolean;
  /** Una respuesta que la persona todavía no vio. */
  novedad: boolean;
}

export function textoDeLaPastilla(e: EstadoDeLaPastilla): string {
  if (e.trabajando) return e.actividad?.trim() || 'El asistente está trabajando…';
  if (e.pregunta) return 'El asistente te pregunta algo';
  if (e.novedad) return 'El asistente te respondió';
  return 'Pedile al asistente';
}

/** Con algo para ver (trabajando, una pregunta, una respuesta sin leer), la conversación; si no, la caja. */
export const alTocarLaPastilla = (e: EstadoDeLaPastilla): Exclude<EstadoDelAgenteMobile, 'pastilla'> =>
  e.trabajando || e.pregunta || e.novedad ? 'chat' : 'caja';
